// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
// =============================================
// TOGGLE MODELO / PRENDA — 2 botones
// =============================================
(function () {
  function initModelToggle() {
    const btns = document.querySelectorAll('.model-toggle-btn[data-toggle-mode]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const mode = btn.dataset.toggleMode; // 'model' o 'flat'

        // Actualizar estado activo de los botones
        btns.forEach(function (b) {
  b.classList.toggle('model-toggle-btn--active', b === btn);
  b.classList.toggle('toolbar-pill--active', b === btn);
});


        // Cambiar imágenes
        document.querySelectorAll('.product-item__toggle-wrap').forEach(function (wrap) {
          const newSrc = mode === 'flat' ? wrap.dataset.flatSrc : wrap.dataset.modelSrc;
          if (!newSrc) return;
          const img = wrap.querySelector('img');
          if (img) {
            img.src = newSrc;
            img.removeAttribute('srcset');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModelToggle);
  } else {
    initModelToggle();
  }

  // MutationObserver para load more / infinite scroll
  const observer = new MutationObserver(function () {
    const activeBtn = document.querySelector('.model-toggle-btn--active[data-toggle-mode]');
    if (!activeBtn || activeBtn.dataset.toggleMode === 'model') return;

    document.querySelectorAll('.product-item__toggle-wrap').forEach(function (wrap) {
      if (wrap.dataset.toggleApplied) return;
      const flatSrc = wrap.dataset.flatSrc;
      if (!flatSrc) return;
      const img = wrap.querySelector('img');
      if (img) {
        img.src = flatSrc;
        img.removeAttribute('srcset');
      }
      wrap.dataset.toggleApplied = 'true';
    });
  });

  const container = document.querySelector('.collection__infinite-container');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }
})();
